import TeamList from '../../react-admin/list/Team/TeamList/TeamList'
import { USER_ADDONS } from './userAddons'

const { ALL } = USER_ADDONS

const RESOURCES = [
  {
    name: 'positions',
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    name: 'team',
    list: TeamList,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
]

export default RESOURCES
